import PieDePagina from '../organismos/PieDePagina';
import CabeceraLanding from '../organismos/Cabecera/CabeceraLanding';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tab, TabList, Tabs } from '@chakra-ui/react';
import { Caja, PilaV } from '../atomos';
import { AVISOS } from '@/routes/AppRoutes';

const PlantillaAvisosLegales = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const links = Object.keys(AVISOS).map((e) => AVISOS[e]);
  const seccionActual = links.indexOf(location.pathname);



  return (
    <PilaV spacing={0} minW={'full'} h={'100dvh'}>
      <CabeceraLanding />
      <Tabs
        marginTop={'97px'}
        background={'layout'}
        w={'full'}
        align='center'
        colorScheme='bGreen'
        defaultIndex={seccionActual}
        position={'fixed'}
        zIndex={'banner'}
      >
        <TabList>
          <Tab
            fontWeight={'semibold'}
            onClick={() => navigate(AVISOS.TERMINOS)}
          >
            Términos y condiciones
          </Tab>
          <Tab
            fontWeight={'semibold'}
            onClick={() => navigate(AVISOS.POLITICAS)}
          >
            Políticas de privacidad
          </Tab>
          <Tab
            fontWeight={'semibold'}
            onClick={() => navigate(AVISOS.TERMINOS_USO)}
          >
            Términos de uso
          </Tab>
        </TabList>
      </Tabs>

      <Caja mt={'139px'} w={'full'}>
        <Outlet />
      </Caja>

      <PieDePagina />
    </PilaV>
  );
};

export default PlantillaAvisosLegales;
